export const addYears = (date: Date, years: number) => {
    date.setFullYear(date.getFullYear() + years);
    return date;
};
export const addDays = (date: Date, days: number) => {
    date.setDate(date.getDate() + days);
    return date;
};
export const addSeconds = (date: Date, seconds: number) => {
    date.setSeconds(date.getSeconds() + seconds);
    return date;
};

export const getNow = (type: 'date' | 'iso' = 'date') => {
    const dateIsoString = new Date().toISOString();
    if (type === 'iso') return dateIsoString;
    return dateIsoString.split('T')[0];
};

export const dateDayDifference = (start: Date, end: Date) => {
    //                                                        ms     s    m    h
    return Math.floor((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24));
};

export const isSameDay = (first: Date, second: Date) => {
    return first.getFullYear() === second.getFullYear() && first.getMonth() === second.getMonth() && first.getDate() === second.getDate();
};

/**
 * Fix for date parsing with timezone offset.
 *
 * `new Date('2025-05-23')` will result in a date of `2025-05-22` in the US because of the timezone difference.
 *
 * This helper fixes it.
 *
 * @param dateString date string like `2025-05-23`
 */
export const parseDateTimezoneFix = (dateString: string) => {
    const parsedDate = new Date(dateString);
    return new Date(parsedDate.setMinutes(parsedDate.getMinutes() + parsedDate.getTimezoneOffset()));
};

export const yearToMonth = (years: number) => Math.floor(years * 12);
